import React, {useRef, useEffect, useState} from 'react';
import Images from "assets/images/imageData";


const CustomModal = ({msg, isPageLoad = false, click = 0, history, url = ''}) => {

    const ref = useRef(null);
    useEffect(() => {
        ref.current.click();
    }, []);


    useEffect(() => {
        ref.current.click();
    }, [click]);

    const handlePageLoad = () => {
        if (isPageLoad) {
            if(url !== ""){
                history.push(url)
            }
            window.location.reload(false);
        }
    }

    return (
        <>
            <div className="">
                <button hidden="hidden" type="button" ref={ref} className="btn btn-info btn-lg" data-toggle="modal"
                        data-target="#myModal"
                >Open
                    Modal
                </button>
                <div className="modal" id="myModal"  style={{'z-index':9999}}>
                    <div className="modal-dialog" style={{"top": "45%", "bottom": "50%"}}>
                        {isPageLoad ? 
                            <div className="modal-content">
                                
                                <div className="modal-header" style={{"backgroundColor": "#1C7CEF"}}>
                                    
                                    <button type="button" className="close" id="close" data-dismiss="modal"
                                            onClick={handlePageLoad}>&times;</button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-center">
                                        
                                        
                                        <div className="success">
                                            <img src={Images?.tick} alt="" />
                                        </div>

                                        <h5 style={{"color": "black"}}> {msg}</h5>
                                    </div>
                                </div>
                            </div>
                        :
                            <div className="modal-content">
                                
                                <div className="modal-header" style={{"backgroundColor": "#1C7CEF"}}>
                                    
                                    <button type="button" className="close" id="close" data-dismiss="modal"
                                            onClick={handlePageLoad}>&times;</button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-center">
                                        
                                        <img src={Images?.ErrorImg} style={{width: "20%"}}></img>
                                        
                                        <h5 style={{"color": "black"}}> {msg}</h5>
                                    </div>
                                </div>
                            </div>
                        }
                        
                    </div>
                </div>
            </div>
        </>
    );
}

export default CustomModal